var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTxtFile = function SvgTxtFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3744 24.3334H8.62564C7.75564 24.3334 7.75564 23.0547 8.62564 23.0547H13.3531C14.2431 23.0547 14.2431 24.3334 13.3531 24.3334H11.6931V29.3797C11.6931 30.2484 10.3731 30.2697 10.3731 29.3797V24.3334H10.3744Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5331 25.4816L19.2731 23.3028C19.7931 22.6241 20.8018 23.4928 20.2331 24.1428C19.6331 24.8528 19.0043 25.6228 18.4031 26.4103L20.4431 28.9491C20.9918 29.6991 19.8931 30.4191 19.3531 29.6791L17.5143 27.3203L15.7056 29.7291C15.1956 30.4578 14.0656 29.6391 14.6368 28.9591L16.6443 26.4103C16.0156 25.6216 15.4056 24.8528 14.7956 24.1428C14.1656 23.3928 15.3356 22.6241 15.7943 23.3241L17.5331 25.4816Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3043 24.3334H21.5568C20.6868 24.3334 20.6868 23.0547 21.5568 23.0547H26.283C27.1731 23.0547 27.1731 24.3334 26.283 24.3334H24.6243V29.3797C24.6243 30.2484 23.3043 30.2697 23.3043 29.3797V24.3334Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
};
export default SvgTxtFile;